export const SSO_FORWARDER_PATH = '/ssos/forward'
export const SSO_CALLBACK_PATH = '/ssos/redirect'
